import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";

export const Reveal = ({ children, i = 0, className = "", as = "div" }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} custom={i} className={className}>
      {children}
    </Comp>
  );
};

export const SectionLabel = ({ children, dark = false, center = false }) => (
  <p className={`overline text-xs mb-5 flex items-center gap-3 ${center ? "justify-center" : ""} ${dark ? "text-[#E03535]" : "text-[#C62828]"}`}>
    <span className="h-px w-8 bg-[#C62828] inline-block" />
    {children}
  </p>
);

export const useCountUp = (end, duration = 1800) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * end));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, end, duration]);

  return { val, ref };
};
